// -*- coding: utf-8 -*-
// Generated by scripts/generate_from_specs.py
// AccessibilityCategories

export default {
    ALT_TEXT: "Lb0tb9VC",
    AUDIO_DESCRIPTION: "LNqKSN9j",
    CAPTIONS_SUBTITLES: "WnIhbgkY",
    HIGH_CONTRAST: "uF4CI2wP",
    SIGN_LANGUAGE: "Dr4cVXkc",
    TAGGED_PDF: "Kxx#meDW",
};
